import { render, staticRenderFns } from "./WedOrderSettlement.vue?vue&type=template&id=324afdea&scoped=true"
import script from "./WedOrderSettlement.vue?vue&type=script&lang=js"
export * from "./WedOrderSettlement.vue?vue&type=script&lang=js"
import style0 from "./WedOrderSettlement.vue?vue&type=style&index=0&id=324afdea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324afdea",
  null
  
)

export default component.exports